<template>
  <modal
    name="chat-join-requests-modal"
    :click-to-close="true"
    width="1000px"
    height="auto"
    :max-width="1000"
    class="select-group-modal modal-custom chat-join-requests-modal"
    transition="easeInOut"
    @before-open="beforeOpened"
    @before-close="beforeClosed"
  >
    <md-card class="modal-header-custom">
      <md-dialog-title class="chat-join-requests-modal__header">
        <div class="chat-join-requests-modal__header-main">
          <div class="chat-join-requests-modal__header-text">
            <span class="neutral_1 heading-500 text-header-modal">Yêu cầu duyệt thành viên nhóm</span>
            <p class="chat-join-requests-modal__description">
              Click vào nhóm yêu cầu để đi đến tab phê duyệt của cuộc trò chuyện
            </p>
          </div>
          <span
            class="material-icons cursor-pointer chat-join-requests-modal__close"
            @click="$modal.hide('chat-join-requests-modal')"
          >close</span>
        </div>
      </md-dialog-title>
    </md-card>

    <md-card-content class="chat-join-requests-modal__body">
      <vue-element-loading :active="loading" spinner="bar-fade-scale" />
      <div v-if="!loading && requests.length === 0" class="chat-join-requests-modal__empty">
        Không có yêu cầu phê duyệt nào
      </div>
      <div v-else class="chat-join-requests-modal__table-wrap">
        <table class="chat-join-requests-modal__table">
          <thead>
            <tr>
              <th>Nhân viên</th>
              <th>Thông tin</th>
              <th>Nhóm yêu cầu</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in requests" :key="requestRowKey(row)">
              <td>
                <div class="chat-join-requests-modal__user">
                  <div class="chat-join-requests-modal__avatar">
                    <md-avatar>
                      <image-template
                        class="avatar"
                        :size="'small'"
                        :image="row.avatar_url"
                        :thumbnail="row.thumbnail"
                        :name="row.fullname"
                      />
                    </md-avatar>
                  </div>
                  <div class="chat-join-requests-modal__user-text">
                    <div class="text-400-medium">{{ row.fullname }}</div>
                    <div class="text-300-default chat-join-requests-modal__username">@{{ row.username || row.id }}</div>
                  </div>
                </div>
              </td>
              <td>
                <div class="chat-join-requests-modal__info">
                  <div class="text-300-default">{{ teamLine(row) }}</div>
                  <div class="text-300-default">{{ positionLine(row) }}</div>
                  <div class="text-300-default chat-join-requests-modal__info-email">{{ row.email || '—' }}</div>
                </div>
              </td>
              <td>
                <button
                  v-if="row.chat_group"
                  type="button"
                  class="chat-join-requests-modal__group"
                  @click="goToGroupApprovalTab(row)"
                >
                  <div class="chat-join-requests-modal__avatar">
                    <md-avatar>
                      <image-template
                        class="avatar"
                        :size="'small'"
                        :image="row.chat_group.avatar"
                        :thumbnail="row.chat_group.thumbnail"
                        :name="row.chat_group.name"
                        img-type="group"
                      />
                    </md-avatar>
                  </div>
                  <span class="chat-join-requests-modal__group-name">{{ row.chat_group.name }}</span>
                </button>
              </td>
              <td>
                <div class="detail-button-wrapper chat-join-requests-modal__actions">
                  <button
                    type="button"
                    class="btn-active text-300-semibold"
                    :disabled="processingKey === actionKey(row, true)"
                    @click="browseRequest(row, true)"
                  >
                    Đồng ý
                  </button>
                  <button
                    type="button"
                    class="btn-stroke text-300-medium"
                    :disabled="processingKey === actionKey(row, false)"
                    @click="browseRequest(row, false)"
                  >
                    Từ chối
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </md-card-content>
  </modal>
</template>

<script>
import ChatService from '../../../store/services/ChatService';
import ImageTemplate from '../../../components/ImageTemplate';

export default {
  name: 'chat-join-requests-modal',
  components: { ImageTemplate },
  data() {
    return {
      loading: false,
      requests: [],
      processingKey: null,
    };
  },
  watch: {
    '$store.state.chat.modifyMessageSocket'(newV) {
      const payload = newV && (newV.modifyData || newV);
      const evType = payload && (payload.type || newV.type);
      const data = payload && (payload.data || newV.data);
      const resolvedEvents = [
        'join_request_resolved',
        'join_request_rejected',
        'join_request_approved',
      ];
      if (!resolvedEvents.includes(evType) || !data || data.user_id == null) {
        return;
      }
      this.removeRequestFromList(data.group_id, data.user_id);
    },
  },
  methods: {
    removeRequestFromList(groupId, userId) {
      const gid = String(groupId);
      const uid = String(userId);
      const next = this.requests.filter(
        (item) => !(String(item.group_id) === gid && String(item.id) === uid),
      );
      if (next.length === this.requests.length) {
        return;
      }
      this.requests = next;
      this.$emit('count-updated', this.requests.length);
    },
    requestRowKey(row) {
      if (row.request_id != null) {
        return `req-${row.request_id}`;
      }
      return `${row.group_id}-${row.id}`;
    },
    beforeOpened() {
      this.fetchRequests();
    },
    beforeClosed() {
      this.requests = [];
      this.processingKey = null;
    },
    teamLine(row) {
      const team = row.parent_department && row.parent_department.name
        ? row.parent_department.name
        : (row.department && row.department.name ? row.department.name : 'CÔNG TY');
      const dept = row.department && row.department.name && row.parent_department
        ? ` > ${row.department.name}`
        : '';
      return `${team}${dept}`;
    },
    positionLine(row) {
      if (row.position && row.position.name) return row.position.name;
      return '—';
    },
    actionKey(row, accept) {
      return `${row.group_id}-${row.id}-${accept ? 'yes' : 'no'}`;
    },
    dedupeRequests(list) {
      const seen = new Set();
      return (list || []).filter((item) => {
        const key = item.request_id != null
          ? `req-${item.request_id}`
          : `${item.group_id}-${item.id}`;
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
    },
    async fetchRequests() {
      this.loading = true;
      try {
        const res = await ChatService.getAllPendingJoinRequests({ page: 1, per_page: 100 });
        this.requests = this.dedupeRequests(res && res.data ? res.data : []);
        this.$emit('count-updated', this.requests.length);
      } catch (e) {
        this.requests = [];
        this.$emit('count-updated', 0);
      } finally {
        this.loading = false;
      }
    },
    async goToGroupApprovalTab(row) {
      const groupId = row && row.group_id != null ? String(row.group_id) : '';
      if (!groupId) return;

      this.$modal.hide('chat-join-requests-modal');

      const { syncMessengerRouteGroup } = await import('@/helper/chatGroupStore');
      const path = `/messenger/${groupId}`;

      if (this.$route.path !== path) {
        await this.$router.push(path).catch((err) => {
          if (!err || err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }

      const refreshed = await syncMessengerRouteGroup(this.$store, groupId);
      const chatGroups = this.$store.state.chat.chatGroups || [];
      const fromList = chatGroups.find((g) => String(g.id) === groupId);
      const base = refreshed || fromList || {
        id: row.group_id,
        name: row.chat_group?.name,
        avatar: row.chat_group?.avatar,
        thumbnail: row.chat_group?.thumbnail,
        type: 'GROUP',
      };

      this.$store.commit('chat/updateChatGroupSelected', {
        ...base,
        open_right_menu: 'member',
        open_member_tab: 3,
        right_bar_visible: true,
      });
    },

    browseRequest(row, accept) {
      const key = this.actionKey(row, accept);
      if (this.processingKey) {
        return;
      }
      this.processingKey = key;
      const joinState = accept ? 'MEMBER' : 'PENDING';
      const previousRequests = this.requests.slice();
      this.removeRequestFromList(row.group_id, row.id);
      ChatService.browseRequestJoinChatGroup({
        group_id: row.group_id,
        user_id: row.id,
        join_state: joinState,
      }).then((res) => {
        if (res && res.status) {
          const textAlert = (accept ? 'Đã chấp nhận ' : 'Đã từ chối ') + row.fullname;
          this.$store.dispatch('alerts/success', textAlert);
          if (this.requests.length === 0) {
            this.$modal.hide('chat-join-requests-modal');
          }
        } else {
          this.requests = previousRequests;
          this.$emit('count-updated', this.requests.length);
          this.$store.dispatch('alerts/error', 'Đã có lỗi xảy ra!');
        }
      }).catch(() => {
        this.requests = previousRequests;
        this.$emit('count-updated', this.requests.length);
        this.$store.dispatch('alerts/error', 'Đã có lỗi xảy ra!');
      }).finally(() => {
        if (this.processingKey === key) {
          this.processingKey = null;
        }
      });
    },
  },
};
</script>

<style lang="scss">
.chat-join-requests-modal.vm--container,
.chat-join-requests-modal.vm--modal {
  z-index: 2100 !important;
}

.vm--overlay[data-modal="chat-join-requests-modal"],
.vm--container.chat-join-requests-modal {
  z-index: 2100 !important;
}

.chat-join-requests-modal {
  .chat-join-requests-modal__header {
    padding: 12px !important;
    line-height: normal !important;
  }

  .chat-join-requests-modal__header-main {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
  }

  .chat-join-requests-modal__header-text {
    flex: 1 1 auto;
    min-width: 0;
  }

  .chat-join-requests-modal__description {
    margin: 6px 0 0;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.45;
    color: #596073;
  }

  .chat-join-requests-modal__close {
    flex-shrink: 0;
  }

  .chat-join-requests-modal__body {
    max-height: min(72vh, 640px);
    overflow: auto;
    padding: 8px 16px 16px;
  }

  .chat-join-requests-modal__empty {
    padding: 24px 8px;
    text-align: center;
    color: #596073;
  }

  .chat-join-requests-modal__table-wrap {
    overflow-x: auto;
  }

  .chat-join-requests-modal__table {
    width: 100%;
    border-collapse: collapse;
    min-width: 720px;

    th,
    td {
      padding: 12px 10px;
      border-bottom: 1px solid #e8eaed;
      vertical-align: top;
      text-align: left;
    }

    th {
      font-weight: 600;
      color: #18202a;
      white-space: nowrap;
    }
  }

  .chat-join-requests-modal__avatar {
    flex-shrink: 0;

    .md-avatar {
      width: 40px !important;
      height: 40px !important;
      min-width: 40px !important;
      min-height: 40px !important;
      overflow: hidden;
      border-radius: 50% !important;
      aspect-ratio: 1 / 1;
    }

    .image-template,
    .image-template.avatar,
    .avatar.image-template {
      position: static !important;
      transform: none !important;
      width: 100% !important;
      height: 100% !important;
      max-width: none !important;
      min-width: 0 !important;
      border-radius: inherit;
    }

    .image-template__img,
    .image-template__initials {
      width: 100% !important;
      height: 100% !important;
      object-fit: cover !important;
      border-radius: inherit;
    }
  }

  .chat-join-requests-modal__user {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 180px;
  }

  .chat-join-requests-modal__username {
    color: #596073;
  }

  .chat-join-requests-modal__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 160px;
    max-width: 280px;
  }

  .chat-join-requests-modal__info-email {
    color: #596073;
    word-break: break-word;
  }

  .chat-join-requests-modal__group {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    min-width: 160px;
    max-width: 240px;
    padding: 4px 6px;
    margin: -4px -6px;
    border: none;
    border-radius: 8px;
    background: transparent;
    text-align: left;
    cursor: pointer;
    transition: background 0.15s ease;

    &:hover {
      background: #f0f7f1;

      .chat-join-requests-modal__group-name {
        color: #1b5e20;
        text-decoration: underline;
      }
    }

    &:active {
      background: #e8f5e9;
    }
  }

  .chat-join-requests-modal__group-name {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    word-break: break-word;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    color: #18202a;
    transition: color 0.15s ease, text-decoration 0.15s ease;
  }

  .chat-join-requests-modal__actions.detail-button-wrapper {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    min-width: 120px;
    width: 120px;
    margin-top: 0;

    button {
      width: 100%;
      cursor: pointer;
      padding: 6px 12px;
    }

    button:hover:not(:disabled) {
      border: #00c853 1px solid;
    }

    button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }
}
</style>
